// extracted by mini-css-extract-plugin
module.exports = {"appointmentStatus":"appointments__AppointmentStatusBadge__appointmentStatus"};